// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"lib-react":1,"vendor-tanstack":1,"vendor-ui-primitives":1,"vendors-node_modules_fontsource-variable_vazirmatn_index_css-node_modules_katex_dist_katex_mi-c19ffc":1 }[chunkId]) return "static/js/" + chunkId + ".js";
  // return url for filenames based on template
  return "static/js/async/" + chunkId + ".js"
}